import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Ledger" hint="JournalEntry + JournalLine from the finance engine." /> }
